import styled from 'styled-components'
import { rem } from 'polished'
import { Box } from 'rebass'
import media from '../../../utils/style'
import { StyledInfoButton } from '../../ContentInfoModal'

const Price = styled.span`
  display: inline-block;
  /* color: ${(props) => props.theme.colors.blue}; */

  & + ${/* sc-selector */ StyledInfoButton} {
    margin-left: 5px;
    margin-right: 0;
  }

  p {
    display: inline-block;
    font-weight: ${(props) => props.theme.weights[1]};

    &:last-child {
      font-weight: ${(props) => props.theme.weights[0]};
    }
  }
`

Price.displayName = 'Price'

const PriceSummary = styled(Box)`
  color: ${(props) => props.theme.colors.grey};
  text-align: left;
  line-height: 1.4;
  margin-bottom: 16px;

  ${media.MediumScreenUp`
  padding-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey_light_op30}
  `};
`

PriceSummary.displayName = 'PriceSummary'

const PriceInstallments = styled(Box)`
  font-size: ${(props) => rem(props.theme.fontSizes[3])};
  white-space: nowrap;
  ${media.LargeScreenUp`
  display: block;
  `};
`

export { Price, PriceSummary, PriceInstallments }
